<template>
  <div class="PaB-product-card-wrapper" :class="{'PaB-product-card-wrapper--compact': compact }">
    <div class="PaB-product-card menu-item"
      :class="{'PaB-product-card--list': layout === 'list', 'PaB-product-card--grid': layout === 'grid'}">
      <header class="PaB-product-card__header" v-if="images" @click="showDetails($event, 0)">
        <div class="PaB-product-card__media">
          <lazy-image :src="product.product_image.md" :alt="product.strain" v-if="!product.product_image.is_default" />
        </div>

        <div class="PaB-product-card__media--vendor">
          <lazy-image :src="product.brand_logo.md" :alt="product.brand" v-if="useBrandLogo && product.brand !== null" />
          <span v-if="useBrandText && product.brand !== null">{{ product.brand }}</span>
        </div>
      </header>

      <div class="PaB-product-card__body">
        <div class="PaB-product-card__details" @click="showDetails($event, 0)">
          <h3 class="PaB-product-card__title">{{ product.name }}</h3>
          <product-meta :useBrandText="useBrandText" :useBrandLogo="useBrandLogo" :product="product" :layout="layout" class="PaB-product-card__meta" />
        </div>

        <div class="PaB-product-card__offer">
          <product-prices :product="product" v-on:show-details-with-variant="showDetails" />
        </div>
      </div>
    </div>

    <app-modal v-if="showingDetails" @close="showingDetails = false" width="720px">
      <template slot="body">
        <product-details :useBrandText="useBrandText" :useBrandLogo="useBrandLogo" :product="product" :orderable="orderable" :initialPriceIndex="initialPriceIndex">
        </product-details>
      </template>
    </app-modal>
  </div>
</template>

<style lang="scss" scoped>
.PaB-product-card-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.PaB-product-card {
  border: 1px solid rgba(#7f7f7f, 0.4);
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  // transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);

    .PaB-product-card__media {
      transform: scale(1.125);
    }
  }

  .PaB-product-card__header {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    // box-shadow: inset 0 0 140px rgba(#7f7f7f, 0.5);
  }

  .PaB-product-card__media--vendor {
    position: absolute;
    margin: 10px;
    max-width: 85px;
    max-height: 100%;
    top: 0;
    background-color: #fff;
    color: #000;
    text-align: center;
    font-weight: bold;

    span {
      padding: 5px;
      display: block;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .PaB-product-card__body {
    flex: 1 1 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;

    .PaB-product-card__details {
      cursor: pointer;
    }
  }

  .PaB-product-card__title {
    font-size: 23px;
    margin-bottom: 0;
  }

  .PaB-product-card__meta {
    margin-top: 8px;
  }

  .PaB-product-card__media {
    overflow: visible;
    transform: scale(1);
    transition: transform 0.25s ease-in-out;

    img {
      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      // width: 100%;
    }
  }

  &--list {
    flex-direction: row;

    .PaB-product-card__media--vendor {
      left: 0;
    }
    .PaB-product-card__header {
      display: flex;
      flex: 0 0 250px;
    }
    .PaB-product-card__media {
      flex: 1;
    }
    .PaB-product-card__body {
      flex: 1 1 80%;
      flex-direction: row;
      justify-content: space-between;
    }
    .PaB-product-card__offer {
      text-align: right;
      display: flex;
      flex-direction: column;
      a {
        margin-top: auto;
      }
    }
    @media screen and (max-width: 600px) {
      .PaB-product-card__header {
        display: none;
      }
      .PaB-product-card__body {
        flex-direction: column;
      }
      .PaB-product-card__offer {
        text-align: left;
      }
    }
  }

  &--grid {
    flex-direction: column;

    .PaB-product-card__media--vendor {
      right: 0;
    }

    .PaB-product-card__media {
      height: 0;
      padding-bottom: 200 / 360 * 100%;
      position: relative;
      display: flex;
      justify-content: center;
      overflow: hidden;

      img {
        // position: absolute;
        // width: 100%;
        height: 200px;
        margin-top: 5px;
      }
    }
    .PaB-product-card__offer {
      margin-top: auto;
      padding-top: 15px;
    }
  }
}

// Compact list view for non-image mode
.PaB-product-card-wrapper--compact {
  .PaB-product-card__body {
    padding: 14px;
  }
  .PaB-product-card--list {
    margin: 4px 0;
  }
}
</style>

<script>
import AppModal from '@/components/AppModal'
import ProductMeta from '@/components/product/ProductMeta'
import ProductPrices from '@/components/product/ProductPrices'
import ProductDetails from '@/components/ProductDetails'
import LazyImage from '@/components/LazyImage'

export default {
  name: 'product-card',
  props: ['product', 'layout', 'orderable'],
  data () {
    return {
      showingDetails: false,
      initialPriceIndex: 0
    }
  },
  components: {
    AppModal,
    ProductMeta,
    ProductPrices,
    ProductDetails,
    LazyImage
  },
  computed: {
    images () {
      return this.widgetOptions.style.product_images
    },
    compact () {
      return this.layout === 'list' && !this.images
    },
    useBrandLogo () {
      return !this.product.brand_logo.is_default && this.widgetOptions.style.display_brands
    },
    useBrandText () {
      return this.product.brand_logo.is_default && this.widgetOptions.style.display_brands
    }
  },
  methods: {
    showDetails (event, priceIndex) {
      if (event) event.preventDefault()
      this.showingDetails = true
      this.initialPriceIndex = priceIndex || 0
    }
  }
}
</script>
